// extracted by mini-css-extract-plugin
module.exports = {"pane":"Accordion_pane__3ds6B","question":"Accordion_question__1fg0H","answer":"Accordion_answer__1IU3X"};